import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
// import cookie from 'react-cookies'
import { useRecoilCallback, useRecoilValueLoadable, useSetRecoilState, useRecoilState } from 'recoil';

// import { storage } from '../Services/storage';

import { DashboardLayout } from '../Layout';
import { BasePage } from './BasePage';
import { Login } from '../Pages/Login';
import { ChangePassword } from '../Pages/ChangePassword';
import { ResetPassword } from '../Pages/ResetPassword';
import { MasterLogin } from '../Pages/MasterLogin';
import { RequestResetPassword } from '../Pages/RequestPasswordReset'
import { LoginPassword } from '../Pages/LoginPassword';
import { Register } from '../Pages/Register';
import { PageLoad } from '../Components/LoadingScreen/PageLoad';

import {
  checkAuthType,
  sendEmail,
  verifyEmail,
  loginWithPassword,
  loginWithoutPassword,
  refreshAuthToken
} from '../Recoil/Selectors/Auth';
import { twoFactorLogin, userInfo, forceLogin } from '../Recoil/Atoms/Login';

const RenderRoutes = ({ history, location: { search, pathname } }) => {
  const [type, setType] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [refresh] = useState(true);
  const [user, setUser] = useRecoilState(userInfo);
  const handleTwoFactorLogin = useSetRecoilState(twoFactorLogin);
  const firebaseUser = useRecoilValueLoadable(verifyEmail(search));
  const mysqlUser = useRecoilValueLoadable(loginWithoutPassword);
  const refreshToken = useRecoilValueLoadable(refreshAuthToken);
  const setForceLoginState = useSetRecoilState(forceLogin);
  const forceUpdate = () => setForceLoginState(n => n + 1);
  
  const submitEmail = useRecoilCallback(({ snapshot }) => async ({ email, setSubmitting, resetForm, setAlert }) => {
    setAlert(null)
    forceUpdate()
    const response = await snapshot.getPromise(
      checkAuthType(email)
    );
    setType(null);
    if(response.success) {
      if(response.result.authenticationType==='1'){
        setAlert({
          status: 'error',
          message: 'User not found!'
        });
      }
      if(response.result.authenticationType === 'two-factor') {
        await snapshot.getPromise(sendEmail(email));
        setAlert({
          status: 'info',
          message: 'An email has been sent to this email address, please open the link in the email'
        });
      } else {
        setUserEmail(email);
      }
      resetForm();
      setSubmitting(false);
      setType(response.result.authenticationType);
    } else {
      setSubmitting(false);
      setAlert({
        status: 'error',
        message: 'Invalid Email'
      });
    }
  });

  const submitPassword = useRecoilCallback(
    ({ snapshot }) => async ({ password, setSubmitting, resetForm, setAlert }) => {
      const response = await snapshot.getPromise(
        loginWithPassword({
          email: userEmail,
          password
        })
      );
      setSubmitting(false);
      if(response.success) {
        resetForm();
        setUser(response.result);
        history.push('/');
      } else {
        setAlert({
          status: 'error',
          message: 'Invalid Password'
        });
      }
    }
  );

  useEffect(() => {
    if(type === 'password') {
      history.push('/login-password');
    }
  }, [type, history]);

  useEffect(() => {
    if(firebaseUser.state === 'hasValue' && firebaseUser?.contents?.success) {
      handleTwoFactorLogin(1);
    }
  }, [firebaseUser, handleTwoFactorLogin]);

  useEffect(() => {
    if(mysqlUser.state !== 'loading' && mysqlUser.contents?.success) {
      setUser(mysqlUser.contents.result.user);
      history.push('/');
    }
  }, [mysqlUser, setUser, history]);

  useEffect(() => {
    // Only reload if refresh token explicitly failed (not just null, which is normal when refetchToken === 0)
    if(refreshToken.state === 'hasValue' && refreshToken.contents && refreshToken.contents.success === false) {
      setUser(null);
      window.location.reload()
    }
  }, [refreshToken, setUser]);
  
  return (
    (( (refreshToken.state === 'loading' && pathname !== '/login' && pathname !== '/login-password') && !refresh ) ||
    ((firebaseUser.state === 'loading' || mysqlUser.state === 'loading') && pathname === '/login')) && !refresh ?
    <PageLoad /> :
    <Switch>
      { user?.user?.isTempPass === '1' || user?.isTempPass === '1'  ? 
        <DashboardLayout>
          <ChangePassword />
        </DashboardLayout>
        :
        user ?
        <DashboardLayout>
          <BasePage />
        </DashboardLayout>
        :
        <Switch>
          <Route
            path='/login'
            render={() => <Login submitEmail={submitEmail} />}
          />
          <Route
            path='/register'
            render={() => <Register />}
          />
          <Route
            path='/resetpassword'
            render={() => <RequestResetPassword />}
          />
          <Route
            path='/reset-password/:token'
            render={() => <ResetPassword />}
          />
          <Route
            path='/master-login/:token'
            render={() => <MasterLogin />}
          />
          { type === 'password' &&
            <Route
              path='/login-password'
              render={() => <LoginPassword submitPassword={submitPassword} />}
            />
          }
          <Redirect to='/login' />
        </Switch>
      }
    </Switch>
  )
};

export default withRouter(RenderRoutes);
